<script setup lang="ts">
const runtimeConfig = useRuntimeConfig()

const version = computed(() => {
  const value = runtimeConfig.public.APP_VERSION
  return value ? `v${value}` : ''
})
</script>

<template>
  <UDashboardGroup class="bg-muted" storage="local">
    <UDashboardSidebar
      class="border-default bg-default"
      :default-size="18"
      :max-size="26"
      :min-size="18"
      :ui="{ footer: 'border-t border-default' }"
      collapsible
      resizable
    >
      <template #toggle>
        <UDashboardSidebarToggle variant="subtle" />
      </template>
      <template #header="{ collapsed }">
        <template v-if="!collapsed">
          <RialticLogo class="h-8 dark:text-white" />
          <div class="flex flex-1 items-center space-x-2 px-2">
            <UBadge color="primary">Admin</UBadge>
            <UColorModeButton />
          </div>
        </template>

        <UDashboardSidebarCollapse
          class="translate-x-1 transform"
          :class="{ 'translate-x-2 transform': !collapsed }"
          variant="subtle"
        />
      </template>

      <template #default="{ collapsed }">
        <NavMenu :collapsed="collapsed" />
      </template>

      <template #footer="{ collapsed }">
        <div class="flex w-full flex-col gap-2 px-2 py-2">
          <div
            class="flex items-center gap-2"
            :class="{
              'justify-center': collapsed,
              'justify-between': !collapsed,
            }"
          >
            <span v-if="!collapsed && version" class="text-muted text-xs">
              {{ version }}
            </span>
            <AuthState v-slot="{ loggedIn, user }">
              <NuxtLink v-if="!loggedIn" to="/auth/auth0" external>
                Login
              </NuxtLink>

              <UButton
                to="/profile"
                :label="collapsed ? undefined : user?.name"
                color="neutral"
                size="md"
                trailing
                variant="ghost"
              >
                <template #trailing>
                  <UAvatar :src="user?.picture" size="sm" />
                </template>
              </UButton>
            </AuthState>
          </div>
        </div>
      </template>
    </UDashboardSidebar>

    <div class="w-full overflow-auto">
      <UDashboardNavbar class="visible lg:hidden" />
      <slot />
    </div>
  </UDashboardGroup>
</template>
